<div class="sn-btn-wrapper tac">
  <button
    *ngIf="this.userSFData?.proxy_url && userSFData?.sf_user_id"
    class="sn-btn btn btn-neutral full-width"
    [disabled]="false"
    (click)="openSnLoginFormAndHandleResult()"
  >
    Try new signNow Login
  </button>

  <div *ngIf="errorMessage" class="error-message">{{errorMessage}}</div>
</div>
